import React, { useState } from 'react';
import { Modal, Button } from 'antd';
import { orderPurchaseQualityQrcode } from '../../../api';

export default function Index(props) {
  const [open, setOpen] = useState(false);
  const handleOk = () => { setOpen(false); };
  const handleCancel = () => { setOpen(false); };
  const containers = (props?.svcInfo || []).map(item => item.container_no).join('/');
  const getOrderPurchaseAgainOrder = async () => {
    const { updateQualityQrcode = () => { }, order_no, quality_qrcode } = props;
    if (quality_qrcode) {
      setOpen(true);
    } else {
      const { data: { data: { quality_qrcode }, code } } = await orderPurchaseQualityQrcode({ order_no });
      if (+code === 0) {
        updateQualityQrcode(quality_qrcode);
        setOpen(true);
      }
    }
  };

  return (
    <div>
      <Button danger onClick={() => getOrderPurchaseAgainOrder()} style={{ marginTop: 30 }}>质检记录分享</Button>
      <Modal width={400} open={open} onOk={handleOk} onCancel={handleCancel} footer={null}  >
        <div style={{ textAlign: 'center' }}>
          <div>请用微信扫描下方小程序码，可分享转发</div>
          <img style={{ margin: '20px auto', width: 200, height: 200 }} src={props.quality_qrcode} alt='' />
          {/* <div>到货质检：{[(props.warehouse_quality_time || '').split(' ')[0].replace(/-/g, ''), containers, props.purchase_name].filter(item => item).join('-')}质检记录</div> */}
          <div>{['到货质检',containers,props.purchase_war_zone_name, props.purchase_name].filter(item => item).join('-')}</div>
        </div>
      </Modal>
    </div>
  );
}
